/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} */
const CpdsIconStyleTag = styled.svg`
    ${({ theme: { styles: { cpds } }}) => {
    return css`
      ${(props) => props?.styleOverrides}
    `}}
`;

export { CpdsIconStyleTag };
